/* Area24: foto's bekijken in een box over de pagina.
   Klik op een productfoto: box met de zichtbare galerijfoto's, pijlen, sluitknop, duimpjes.
   Wisselen met pijltjestoetsen of swipen; sluiten met Esc, de knop of naast de box klikken.
   Vervangt het schermvullende zoomvenster van Dawn (alleen voor foto's; video's houden het oude gedrag). */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let box, track, counter, thumbs, prevBtn, nextBtn, closeBtn;
  let items = [];
  let index = 0;
  let lastFocus = null;

  const big = (src, w) => {
    try { const u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  };

  function build() {
    box = document.createElement('div');
    box.className = 'a24-lb';
    box.hidden = true;
    box.innerHTML = `
      <div class="a24-lb__backdrop" data-close></div>
      <div class="a24-lb__panel" role="dialog" aria-modal="true" aria-label="Foto's" tabindex="-1">
        <button type="button" class="a24-lb__close" aria-label="Sluiten" data-close>
          <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>
        </button>
        <div class="a24-lb__stage">
          <div class="a24-lb__track"></div>
          <button type="button" class="a24-lb__nav a24-lb__nav--prev" aria-label="Vorige foto">
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button type="button" class="a24-lb__nav a24-lb__nav--next" aria-label="Volgende foto">
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
        <div class="a24-lb__foot">
          <p class="a24-lb__count" aria-live="polite"></p>
          <div class="a24-lb__thumbs"></div>
        </div>
      </div>`;
    document.body.appendChild(box);
    track = box.querySelector('.a24-lb__track');
    counter = box.querySelector('.a24-lb__count');
    thumbs = box.querySelector('.a24-lb__thumbs');
    prevBtn = box.querySelector('.a24-lb__nav--prev');
    nextBtn = box.querySelector('.a24-lb__nav--next');
    closeBtn = box.querySelector('.a24-lb__close');

    box.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) close(); });
    prevBtn.addEventListener('click', () => go(index - 1));
    nextBtn.addEventListener('click', () => go(index + 1));
    thumbs.addEventListener('click', (e) => { const t = e.target.closest('button[data-i]'); if (t) go(+t.dataset.i); });
    document.addEventListener('keydown', onKey);
    swipe(box.querySelector('.a24-lb__stage'));
  }

  function onKey(e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    else if (e.key === 'Tab') {
      // focus binnen de box houden
      const f = [...box.querySelectorAll('button:not([hidden])')].filter((b) => b.offsetParent);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function swipe(stage) {
    let x0 = null, y0 = 0, dx = 0, id = null, horizontal = null;
    stage.addEventListener('pointerdown', (e) => {
      if (e.target.closest('button') || items.length < 2) return;
      x0 = e.clientX; y0 = e.clientY; dx = 0; id = e.pointerId; horizontal = null;
      track.style.transition = 'none';
    });
    stage.addEventListener('pointermove', (e) => {
      if (x0 === null || e.pointerId !== id) return;
      dx = e.clientX - x0;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(e.clientY - y0) > 6)) {
        horizontal = Math.abs(dx) > Math.abs(e.clientY - y0);
        if (horizontal) stage.setPointerCapture(id);
      }
      if (!horizontal) return;
      const edge = (index === 0 && dx > 0) || (index === items.length - 1 && dx < 0);
      track.style.transform = `translateX(calc(${-index * 100}% + ${edge ? dx / 3 : dx}px))`;
    });
    const end = (e) => {
      if (x0 === null || e.pointerId !== id) return;
      track.style.transition = '';
      const w = stage.clientWidth || 1;
      if (horizontal && Math.abs(dx) > Math.min(80, w * 0.18)) go(index + (dx < 0 ? 1 : -1));
      else go(index);
      x0 = null;
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function load(i) {
    const img = track.children[i]?.querySelector('img');
    if (img && !img.src) { img.src = img.dataset.src; img.srcset = img.dataset.srcset; }
  }

  function go(i) {
    if (!items.length) return;
    index = Math.max(0, Math.min(items.length - 1, i));
    track.style.transform = `translateX(${-index * 100}%)`;
    [index, index - 1, index + 1].forEach(load);
    counter.textContent = `${index + 1} / ${items.length}`;
    const had = document.activeElement;
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === items.length - 1;
    // knop die uitgaat terwijl hij focus heeft: focus naar de andere pijl
    if (had && had.disabled) (had === prevBtn ? nextBtn : prevBtn).focus({ preventScroll: true });
    [...thumbs.children].forEach((t, k) => t.setAttribute('aria-current', k === index ? 'true' : 'false'));
    const at = thumbs.children[index];
    if (at) at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }

  function open(list, start, title) {
    if (!box) build();
    items = list;
    box.querySelector('.a24-lb__panel').setAttribute('aria-label', title ? `Foto's van ${title}` : "Foto's");
    track.innerHTML = items.map((it, k) => `
      <figure class="a24-lb__slide" aria-roledescription="dia" aria-label="Foto ${k + 1} van ${items.length}">
        <img data-src="${big(it.src, 1600)}" data-srcset="${big(it.src, 900)} 900w, ${big(it.src, 1300)} 1300w, ${big(it.src, 1800)} 1800w"
             sizes="(min-width: 990px) 900px, 92vw" alt="${(it.alt || '').replace(/"/g, '&quot;')}" draggable="false">
      </figure>`).join('');
    thumbs.innerHTML = items.length > 1 ? items.map((it, k) => `
      <button type="button" data-i="${k}" aria-label="Foto ${k + 1}"><img src="${big(it.src, 160)}" alt="" loading="lazy" draggable="false"></button>`).join('') : '';
    box.classList.toggle('is-single', items.length < 2);
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('a24-lb-open');
    track.style.transition = 'none';
    go(start);
    requestAnimationFrame(() => { track.style.transition = ''; box.classList.add('is-open'); closeBtn.focus({ preventScroll: true }); });
  }

  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('a24-lb-open');
    const done = () => { box.hidden = true; if (lastFocus) lastFocus.focus({ preventScroll: true }); };
    if (reduce) done(); else setTimeout(done, 220);
  }

  // klik op een productfoto onderscheppen voordat Dawn zijn eigen venster opent
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.product__media-list .product__media-toggle');
    if (!toggle) return;
    const list = toggle.closest('.product__media-list');
    // Dawn zet alleen de foto's van de gekozen variant in de lijst; op desktop zijn de niet-actieve verborgen, dus niet op zichtbaarheid filteren
    const all = [...list.querySelectorAll(':scope > .product__media-item')];
    const pics = all.map((li) => ({ li, img: li.querySelector('.product__media img') }))
      .filter((p) => p.img && p.li.querySelector('.product-media-container.media-type-image'));
    const here = toggle.closest('.product__media-item');
    const start = pics.findIndex((p) => p.li === here);
    if (start < 0) return; // video of 3D: oude gedrag
    e.preventDefault();
    e.stopImmediatePropagation();
    const title = document.querySelector('.product__title h1')?.textContent.trim();
    open(pics.map((p) => ({ src: p.img.currentSrc || p.img.src, alt: p.img.alt })), start, title);
  }, true);
})();
